<template>
  <footer role="contentinfo" aria-label="Pie de página de ChileAtiende">
    <div class="container">
      <div class="columns">
        <div class="column web">
          <h3>SOBRE CHILEATIENDE</h3>
          <ul class="links-footer">
            <li>
              <a href="/que-es-chileatiende" title="Página con la información sobre ChileAtiende"
                >Sobre ChileAtiende</a
              >
            </li>
            <li>
              <a
                href="/instituciones/"
                title="Página con la lista de instituciones que publican en el portal de ChileAtiende"
                >Instituciones que publican en el Portal</a
              >
            </li>
          </ul>
        </div>
        <div class="column web">
          <h3>TÉRMINOS Y CONDICIONES</h3>
          <ul class="links-footer">
            <li>
              <a
                href="/politica-de-privacidad"
                title="Página con la política de privacidad que tiene ChileAtiende"
                >Política de privacidad</a
              >
            </li>
            <li>
              <a
                href="/terminos-y-condiciones"
                title="Página con los términos y condiciones de uso de los servicios en ChileAtiende"
                >Términos de uso</a
              >
            </li>
          </ul>
          <h3 class="mt-7">API PARA DESARROLLADORES</h3>
          <ul class="links-footer">
            <li>
              <a
                href="/desarrolladores"
                title="Página para desarrolladores que contiene toda la asistencia de la API de ChileAtiende"
                >API</a
              >
            </li>
          </ul>
        </div>
        <div class="column">
          <h3>CONTÁCTANOS</h3>
          <ul class="links-footer">
            <li>
              <a
                href="/red-de-atencion"
                title="Página que contiene el formulario de contacto del servicio de asistencia"
                >Redes de atención
              </a>
            </li>
          </ul>
        </div>
        <div class="column">
          <h3>NUESTRAS REDES SOCIALES</h3>
          <div class="links-footer">
              <a
                href="https://www.facebook.com/ChileAtiende"
                target="_blank"
                title="Fanpage oficial de ChileAtiende en Facebook"
                ><img
                  src="/images/landing-sucursal-virtual/icon-facebook.svg"
                  alt="Icono de facebook"
                />
              </a>
              <a
                href="https://www.instagram.com/chileatiende/"
                target="_blank"
                title="Pagina oficial de ChileAtiende en Instagram"
                ><img
                  src="/images/landing-sucursal-virtual/icon-instagram.svg"
                  alt="Icono de Instagram"
                />
              </a>
              <a
                href="https://twitter.com/ChileAtiende"
                target="_blank"
                title="Pagina oficial de ChileAtiende en X"
                ><img
                  src="/bulma/images/icon-x.svg"
                  alt="Icono de X"
                />
              </a>
              <a
                href="https://www.tiktok.com/@chileatiende_oficial"
                target="_blank"
                title="Pagina oficial de ChileAtiende en TikTok"
                ><img
                  src="/images/icon-tiktok.svg"
                  alt="Icono de TikTok"
                />
              </a>
              <a
                href="https://www.youtube.com/user/ChileAtiende/featured"
                target="_blank"
                title="Canal oficial de ChileAtiende en Youtube"
                ><img
                  src="/images/landing-sucursal-virtual/icon-youtube.svg"
                  alt="Icono de Youtube"
                />
              </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>
